import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

type FilterButtonBarProps = {
  onSelectAll: () => void;
  onClear: () => void;
  disableSelectAll: boolean;
  selectAllButtonTrackingId?: string;
  clearButtonTrackingId?: string;
};

export const FilterButtonBar = ({
  onSelectAll,
  onClear,
  disableSelectAll,
  selectAllButtonTrackingId,
  clearButtonTrackingId,
}: FilterButtonBarProps) => {
  const { t } = useTranslation('scheduleCalendarFilters');

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: theme.spacing(0.5, 0),
        width: '100%',
      }}
    >
      <Button
        variant='tertiary'
        onClick={onSelectAll}
        disabled={disableSelectAll}
        trackingId={selectAllButtonTrackingId}
      >
        {t('Select All')}
      </Button>
      <Button variant='tertiary' trackingId={clearButtonTrackingId} onClick={onClear}>
        {t('Clear')}
      </Button>
    </div>
  );
};
